var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 25,
    viewBox: "0 0 118 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.34 12.9184C70.8069 27.4754 35.9203 27.9862 0 15.983C2.58419 13.3015 4.78076 14.323 6.46049 14.8338C19.3815 18.2815 32.6901 18.6646 45.8694 19.1754C64.8633 19.9415 82.8234 15.5999 100.396 8.5768C101.171 8.32141 101.817 7.81065 103.368 6.7891C94.4523 5.00139 85.5368 8.06605 77.7842 4.49064C77.9135 3.97986 77.9135 3.34137 78.0427 2.8306C83.8571 2.44752 89.8008 2.06444 95.6152 1.55367C101.43 1.04289 107.115 0.404451 112.929 0.0213707C117.193 -0.234016 119.002 1.80907 117.452 5.63987C115.513 10.6199 112.8 15.2168 110.345 19.9415C110.087 20.4523 109.699 21.0907 109.182 21.3461C107.761 21.8569 106.34 21.9846 104.789 22.3677C104.531 21.0908 103.885 19.6861 104.014 18.5369C104.272 17.0046 105.177 15.7276 106.34 12.9184Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrArrow);
export default __webpack_public_path__ + "static/media/qrArrow.b1e6c405c98a5e60955d4860d86482b4.svg";
export { ForwardRef as ReactComponent };